<template>
  <column-layout class="page" sticky-sides noRight>
    <!-- Left -->
    <template v-slot:left>
      <AdminMenu />
    </template>

    <!-- Main -->
    <template>
      <div class="widget">
        <label class="label">
          {{ $t("reports.reports") }}
        </label>

        <div class="card pa">
          <div class="stat-boxes">
            <StatBox
              v-for="(box, i) in boxes"
              :key="i"
              :label="box.label"
              :value="box.value"
              :loading="!!$loading('admin/statsByType')"
            />
          </div>

          <ReportsTable class="mt-10" />
        </div>
      </div>
    </template>
  </column-layout>
</template>

<script>
import AdminMenu from "@/components/admin/AdminMenu.vue";
import ReportsTable from "@/components/admin/reports/ReportsTable.vue";
import StatBox from "@/components/admin/StatBox.vue";

export default {
  metaInfo: { title: "Reports" },

  components: { AdminMenu, ReportsTable, StatBox },

  data: () => ({
    stats: {
      total_reports: null,
      total_reports_comments: null,
      total_reports_groups: null,
      total_reports_posts: null,
      total_reports_users: null,
    },
  }),

  computed: {
    boxes() {
      return [
        {
          label: this.$t("reports.totalReports"),
          value: this.stats.total_reports,
        },
        {
          label: this.$t("reports.userReports"),
          value: this.stats.total_reports_users,
        },
        {
          label: this.$t("reports.groupReports"),
          value: this.stats.total_reports_groups,
        },
        {
          label: this.$t("reports.postReports"),
          value: this.stats.total_reports_posts,
        },
        {
          label: this.$t("reports.commentReports"),
          value: this.stats.total_reports_comments,
        },
      ];
    },
  },

  created() {
    this.fetchStats();
  },

  methods: {
    fetchStats() {
      this.$store
        .dispatch("admin/statsByType", "report")
        .then((stats) => {
          this.stats = stats;
        })
        .catch(() => {
          this.$toast.error("Error while fetching stats for reports.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss"></style>
